import { useState } from 'react';
import {
    SUITS_ME_APP_STORE,
    SUITS_ME_GOOGLE_PLAY_STORE,
} from 'lib/constants/routes';
import Typography from 'components/shared/generic/typography/presentational/Typography';
import SuitsMeLogo from '_content/images/logos/SuitsMe_Logo_Gradient.svg';
import AppStoreBadge from '_content/images/app-store/app-store-badge.png';
import GooglePlayBadge from '_content/images/app-store/google-play-badge.png';
import { isIOS } from 'constants/shared/platform';

const GetApp = () => {
    const [hasClicked, setHasClicked] = useState(false);

    const store = isIOS
        ? {
              url: SUITS_ME_APP_STORE,
              badge: AppStoreBadge,
              alt: 'Download on the App Store',
          }
        : {
              url: SUITS_ME_GOOGLE_PLAY_STORE,
              badge: GooglePlayBadge,
              alt: 'Get it on Google Play',
          };

    const handleStoreClick = () => {
        setHasClicked(true);
        setTimeout(() => {
            globalThis.close();
        }, 50);
    };

    return (
        <div className="login-container get-app">
            <img src={SuitsMeLogo} alt="Suits Me" className="logo mt-4" />
            <Typography tag="h1" className="mt-4">
                Get the app
                <br />
                to continue
            </Typography>
            <Typography tag="p" className="mt-2">
                Manage your card, view transactions, and get instant
                notifications - all from your phone.
            </Typography>
            {!hasClicked && (
                <div className="get-app__badge mt-4">
                    <a
                        href={store.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={handleStoreClick}
                    >
                        <img src={store.badge} alt={store.alt} />
                    </a>
                </div>
            )}
            {hasClicked && (
                <Typography tag="p" className="mt-4">
                    You can close this tab now.
                </Typography>
            )}
        </div>
    );
};

export default GetApp;
